import __request__ from "routing/request";
export function sidecars(sort = "node_name", page = 1, per_page = 50, query, order = "asc", only_active = false, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.sidecar/sidecars", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order, "only_active": only_active }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function all(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.sidecar/sidecars/all", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function assignConfiguration(JSONbody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.sidecar/sidecars/configurations", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getBasicSidecarUser(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.sidecar/sidecars/user", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(sidecarId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.sidecar/sidecars/${sidecarId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function register(sidecarId, JSONbody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.sidecar/sidecars/${sidecarId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
